module.exports = __webpack_public_path__ + "img/1571223656.50fdcb9d.jpg";